import GlobalStore from "@/store";

export function getBigPicture(picture: string, shopId: number) {
    if (!picture) return "";

    const { shopMapping } = GlobalStore;

    const shop = shopMapping.get(shopId);

    if (!shop) return picture;

    const shopType = shop.type;

    try {
        // 淘宝 https://img.alicdn.com/bao/uploaded/i3/1609797901/TB2BQPWXBUSMeJjSszeXXcKgpXa_!!1609797901.jpg_60x60.jpg
        if (shopType === "TAOBAO") {
            if (picture.indexOf("_60x60.jpg")) {
                return picture.replace("_60x60.jpg", "");
            }

            if (picture.indexOf("_300x300.jpg")) {
                return picture.replace("_300x300.jpg", "");
            }

            return picture;
        }
        // 阿里巴巴 https://cbu01.alicdn.com/img/order/trading/305/378/524737368031/4853116385_56700090.80x80.jpg
        if (shopType === "ALIBABA") {
            return picture.replace(".80x80", "");
        }
        // 折800 http://z2.tuanimg.com/imagev2/trade/700x700.9406fe2f5b4663eba168e95d83771989.58x58.jpg
        if (shopType === "ZHE800") {
            return picture.replace(".58x58", "");
        }
        if (shopType === "WEIDIAN") {
            return picture.replace("w=110&h=110&", "");
        }
        return picture;
    } catch (e) {
        return picture;
    }
}
